import React, { useEffect, useContext, useState, useRef } from "react";
import "./popup.css";

interface PopupProps {
  show: boolean;
  onClose: () => void;
  accountAndVersion: any;
  sampleSize: string;
  reportType: string;
  startDate: string;
  endDate: string;
  handleCalculateCostAccuracyReport: Function;
}

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  SelectChangeEvent,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { getDateString } from "../../utils/data/datetime";

const Popup: React.FC<PopupProps> = ({
  show,
  onClose,
  accountAndVersion,
  sampleSize,
  reportType,
  startDate,
  endDate,
  handleCalculateCostAccuracyReport,
}) => {
  if (!show) {
    return null;
  }
  const [loading, setLoading] = useState(false);

  return (
    <div className="popup" style={{ zIndex: "1" }}>
      <div className="popup-content">
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>
        <h2 className="popup-title">Accuracy Report Generation</h2>
        <p className="popup-subtitle">
          This report is run to analyse the chatbot’s accuracy by analysing the
          real world responses with ChatGPT 4o
        </p>
        <Box
          display="flex"
          flexDirection="column"
          className="platform-card-container-estimated-cost"
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="left"
            sx={{
              height: "30px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              Estimated Cost
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="left"
            sx={{
              height: "10px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              $49.859
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              marginBottom: "10px",
              marginTop: "0px",
              marginLeft: "5px",
            }}
          ></Box>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          className="platform-card-container-estimated-cost platform-card-container-estimated-genrate-report"
        >
          <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            marginLeft="15%"
            sx={{
              height: "0px",
            }}
          >
            <Typography
              sx={{
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
                height: "18px",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                color: "#092146",
                opacity: "0.6",
              }}
            >
              Account :{" "}
              {accountAndVersion &&
              accountAndVersion?.name &&
              accountAndVersion?.productVersion
                ? `${accountAndVersion?.name} - ${accountAndVersion?.productVersion}`
                : ""}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              marginBottom: "10px",
              marginTop: "10px",
              marginLeft: "5px",
            }}
          ></Box>

          <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            marginLeft="15%"
            sx={{
              height: "10px",
            }}
          >
            <Typography
              sx={{
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
                height: "18px",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                color: "#092146",
                opacity: "0.6",
              }}
            >
              Report Type: {reportType}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              marginBottom: "10px",
              marginTop: "0px",
              marginLeft: "5px",
            }}
          ></Box>

          <Box
            display="flex"
            justifyContent="left"
            marginLeft="15%"
            alignItems="left"
            sx={{
              height: "10px",
            }}
          >
            <Typography
              sx={{
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
                height: "18px",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                color: "#092146",
                opacity: "0.6",
              }}
            >
              Sample Size : {sampleSize}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            sx={{
              marginBottom: "10px",
              marginTop: "0px",
              marginLeft: "5px",
            }}
          ></Box>

          <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            marginLeft="15%"
            sx={{
              height: "10px",
            }}
          >
            <Typography
              sx={{
                marginLeft: "5px",
                textAlign: "center",
                marginTop: "10px",
                height: "18px",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                color: "#092146",
                opacity: "0.6",
              }}
            >
              Report date : {getDateString(startDate)} to{" "}
              {getDateString(endDate)}
            </Typography>
          </Box>

          <Button
            className="feature-config-btns"
            onClick={() => handleCalculateCostAccuracyReport()}
            variant="text"
            sx={{
              fontSize: "14px",
              backgroundColor: "#2858D3",
              color: "#FFFFFF",
              fontFamily: "Poppins",
              fontStyle: "normal",
              fontWeight: "600",
              marginLeft: "13%",
              marginTop: "10%",
              width: "80%",
              "&:hover": {
                backgroundColor: "rgba(1, 87, 255, 0.2)",
              },
            }}
          >
            GENERATE REPORT
            {loading && <div className="loader2"></div>}
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default Popup;
